jQuery(function($) {
  "use strict";

  if (
    $(".hero__slider.has-multiple").length &&
    !$(".hero__slider.has-multiple").hasClass("slick-initialized")
  ) {
    $(".hero__slider.has-multiple").slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 2000,
      fade: true,
      cssEase: "linear",
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: false,
      pauseOnFocus: false,
    });
  }

  var $homePopup = $("#home-popup");
  if ($homePopup.length) {
    $homePopup.addClass("is-hidden");
    
    setTimeout(function() {
      $homePopup
        .removeClass("is-hidden")
        .attr("aria-hidden", "false")
        .css("display", "flex")
        .hide()
        .fadeIn(600);
    }, 3000);
    
    $homePopup.on("click", function(event) {
      if ($(event.target).closest("[data-home-popup-close]").length) {
        $homePopup.fadeOut(300, function() {
          $homePopup
            .addClass("is-hidden")
            .attr("aria-hidden", "true")
            .css("display", "");
        });
      }
    });
  }

  // Hero animation
  $("#home-hero").scrollAnimations({
    animationGroups: [
      {
        selector: ".hero__content h1",
        delay: 300,
        animation: "fadeInUp",
      },
      {
        selector: ".hero__content p",
        delay: 600,
        animation: "fadeInUp",
      },
      {
        selector: ".hero__content .btn",
        delay: 800,
        animation: "scaleIn",
      },
    ],
  });

  // Overview Animation
  $("#home-overview").scrollAnimations({
    animationGroups: [
      {
        selector: ".left", // Written content
        delay: 300,
        animation: "fadeInLeft", // Slides from left + fades in
      },
      {
        selector: ".right", // Video
        delay: 300,
        animation: "fadeInRight", // Slides from right + fades in
      },
    ],
  });

  // Am I Elegible Animation
  $("#home-am-i-eligible").scrollAnimations();
  $("#home-am-i-eligible").scrollAnimations({
    animationGroups: [
      {
        selector: ".overlay",
        delay: 600,
        animation: "scaleIn",
        stagger: true,
      },
    ],
  });

  // Featured Events Animation
  $("#home-events").scrollAnimations({
    animationGroups: [
      {
        selector: ".left", // Written content
        delay: 300,
        animation: "fadeInLeft", // Slides from left + fades in
      },
      {
        selector: ".right", // Cards
        delay: 300,
        animation: "fadeInRight", // Slides from right + fades in
      },
    ],
  });

  // Latest News Animation
  $("#home-latest-news").scrollAnimations({
    animationGroups: [
      {
        selector: ".news__item",
        delay: 300,
        animation: "fadeIn",
        stagger: true,
        staggerDelay: 250,
      },
    ],
  });
});



// WEBPACK FOOTER //
// ./resources/assets/scripts/home.js